import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AssetTransferStepperComponent } from '../asset-transfer-stepper/asset-transfer-stepper.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';

@Component({
  selector: 'app-asset-transfer-approve-details',
  templateUrl: './asset-transfer-approve-details.component.html',
  styleUrls: ['./asset-transfer-approve-details.component.scss']
})
export class AssetTransferApproveDetailsComponent implements OnInit {
  constructor(private dialog: NgDialogAnimationService) { }
  ngOnInit(): void {

  }

  pending() {
    const dialogRef = this.dialog.open(AssetTransferStepperComponent, {
      height: '100%',
      width: '40%',
      direction: 'ltr',
      position: { right: '0px', top: '0px' },
      animation: { to: 'left' }
    });


  }
}
